import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchSubprocessen,
} from '../services/searchSubprocessen'

import { useSubprocessenSearchStore } from './useSubprocessenSearchStore'

export { useSubprocessenSearch, queryKey }

const queryKey = 'subprocessen'

const useQueryStore = () => {
  const { query, storeQuery } = useSubprocessenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useSubprocessenSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchSubprocessen({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
